import { lang, _lang } from '@umu/ukit-lang';
import './whitePaperContent.scss';
import React from 'react';
import { localStorageHelper, STORAGE_KEY } from '@umu/umu-storage';

import { If } from 'common/src/components';

import Form from 'cms/common/form';
import { FormType } from 'cms/common/form/interface';

interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
    hasSubmitted: boolean;
    changeHasSubmitted: Function;
}

const WHITE_PAPER_URL =
    'https://statics-cdn-cn.umucdn.cn/statics/home/%E6%B7%B7%E5%90%88%E5%BC%8F%E5%AD%A6%E4%B9%A03.0.pdf';

export const WhitePaperContent = (props: IProp) => {
    localStorageHelper.set(STORAGE_KEY.AREA_CODE, '');

    return (
        <If condition={!props.hasSubmitted}>
            <div
                className={
                    props.platform === 'twww' ? 'white-paper-content' : 'white-paper-content white-m-paper-content'
                }
            >
                <div className="content-form">
                    <If condition={props.platform === 'mobile'}>
                        <h2 className="form-tip">
                            {lang('在填写并提交表格后，您将收到来自 UMU 的企业学习报告，行业指南与促销、活动信息。')}
                        </h2>
                    </If>
                    <Form
                        type={FormType.whitePaper}
                        downloadUrl={WHITE_PAPER_URL}
                        referUrl={props.referUrl}
                        platform={props.platform}
                        changeHasSubmitted={props.changeHasSubmitted}
                    />
                </div>
                <div className="content-wrapper">
                    <div className="title">{lang('数字时代企业学习变革')}</div>
                    <div className="des des-bottom">
                        <span>
                            {lang(
                                '专注于效果学习的 UMU 与中国领先的人力资源智库 HRflag 携手，调研数百家不同行业、规模、性质的企业，并深入访谈众多高管，综合思考洞察、萃取案例与实践建议，正式发布了混合式学习 3.0 白皮书。',
                            )}
                        </span>
                    </div>
                    <div className="title">{lang('包含内容')}</div>
                    <div className="help-des">
                        <div className="yes-icon"></div>
                        <div className="des">{lang('企业混合式学习的现状、挑战分析')}</div>
                    </div>
                    <div className="help-des">
                        <div className="yes-icon"></div>
                        <div className="des">{lang('混合式学习的演进、趋势与发展策略')}</div>
                    </div>
                    <div className="help-des">
                        <div className="yes-icon"></div>
                        <div className="des">{lang('混合式学习 3.0 的核心特征与价值')}</div>
                    </div>
                    <div className="help-des des-bottom">
                        <div className="yes-icon"></div>
                        <div className="des">{lang('如何迈入混合式学习 3.0 的实操方法')}</div>
                    </div>
                </div>
            </div>
        </If>
    );
};
